import React, { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

/* ── Passwort Tab ─────────────────────────────────────── */
function PasswortTab({ benutzername }) {
  const [data, setData]       = useState({ neu: '', bestaetigen: '' })
  const [error, setError]     = useState('')
  const [success, setSuccess] = useState('')
  const [loading, setLoading] = useState(false)

  const speichern = async (e) => {
    e.preventDefault()
    setError(''); setSuccess('')
    if (data.neu.length < 6)             { setError('Mindestens 6 Zeichen'); return }
    if (data.neu !== data.bestaetigen)   { setError('Passwörter stimmen nicht überein'); return }
    setLoading(true)
    const { error: err } = await supabase.auth.updateUser({ password: data.neu })
    if (err) { setError(err.message) }
    else     { setSuccess('Passwort wurde erfolgreich geändert.'); setData({ neu: '', bestaetigen: '' }) }
    setLoading(false)
  }

  return (
    <div style={{ maxWidth: 420 }}>
      <div style={{ fontSize: 14, fontWeight: 700, color: '#0d1b2a', marginBottom: 4 }}>Passwort ändern</div>
      <div style={{ fontSize: 12, color: '#9ca3af', marginBottom: 20 }}>Eingeloggt als: <strong>{benutzername}</strong></div>
      <form onSubmit={speichern}>
        <div style={{ marginBottom: 14 }}>
          <label style={lbl}>Neues Passwort</label>
          <input type="password" style={inp} placeholder="mind. 6 Zeichen"
            value={data.neu} onChange={e => setData({ ...data, neu: e.target.value })} autoComplete="new-password" />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={lbl}>Passwort bestätigen</label>
          <input type="password" style={inp} placeholder="wiederholen"
            value={data.bestaetigen} onChange={e => setData({ ...data, bestaetigen: e.target.value })} autoComplete="new-password" />
        </div>
        {error   && <div style={{ color: '#c53030', fontSize: 12, marginBottom: 10, background: '#fff5f5', padding: '7px 12px', borderRadius: 7 }}>⚠ {error}</div>}
        {success && <div style={{ color: '#276749', fontSize: 12, marginBottom: 10, background: '#f0fff4', padding: '7px 12px', borderRadius: 7 }}>✓ {success}</div>}
        <button type="submit" disabled={loading}
          style={{ padding: '9px 22px', background: '#ffc000', color: '#111111', border: 'none', borderRadius: 7, cursor: 'pointer', fontWeight: 800, fontSize: 13 }}>
          {loading ? 'Speichern...' : '✓ Passwort speichern'}
        </button>
      </form>
    </div>
  )
}

/* ── Benutzer Tab ─────────────────────────────────────── */
function BenutzerTab() {
  const [liste, setListe]           = useState([])
  const [form, setForm]             = useState({ benutzername: '', email: '', passwort: '' })
  const [loading, setLoading]       = useState(false)
  const [error, setError]           = useState('')
  const [success, setSuccess]       = useState('')
  const [delConfirm, setDelConfirm] = useState(null)
  const [deleting, setDeleting]     = useState(false)
  const [editId, setEditId]         = useState(null)
  const [editName, setEditName]     = useState('')

  useEffect(() => { laden() }, [])

  const laden = async () => {
    const { data } = await supabase.from('benutzer').select('*').order('created_at', { ascending: true })
    setListe(data || [])
  }

  const hinzufuegen = async (e) => {
    e.preventDefault()
    setError(''); setSuccess('')
    if (!form.benutzername.trim()) { setError('Benutzername erforderlich'); return }
    if (!form.email.trim())        { setError('E-Mail erforderlich'); return }
    if (form.passwort.length < 6)  { setError('Passwort: mindestens 6 Zeichen'); return }
    if (liste.find(b => b.benutzername === form.benutzername.toLowerCase().trim())) {
      setError('Benutzername bereits vergeben!'); return
    }
    setLoading(true)

    const { data: { session: adminSession } } = await supabase.auth.getSession()
    const { error: authErr } = await supabase.auth.signUp({
      email: form.email.toLowerCase().trim(), password: form.passwort,
    })
    if (adminSession) {
      await supabase.auth.setSession({ access_token: adminSession.access_token, refresh_token: adminSession.refresh_token })
    }

    if (authErr && !authErr.message?.toLowerCase().includes('already registered')) {
      setError(`Fehler: ${authErr.message}`); setLoading(false); return
    }

    const { error: dbErr } = await supabase.from('benutzer').insert({
      benutzername: form.benutzername.toLowerCase().trim(),
      email:        form.email.toLowerCase().trim(),
    })
    if (dbErr) {
      setError(dbErr.code === '23505' ? 'Benutzername oder E-Mail bereits vergeben!' : dbErr.message)
    } else {
      setSuccess(`Benutzer „${form.benutzername}" wurde angelegt.`)
      setForm({ benutzername: '', email: '', passwort: '' })
      laden()
    }
    setLoading(false)
  }

  const benutzernameAendern = async (id) => {
    if (!editName.trim()) return
    await supabase.from('benutzer').update({ benutzername: editName.toLowerCase().trim() }).eq('id', id)
    setEditId(null); laden()
  }

  const loeschen = async () => {
    setDeleting(true)
    await supabase.from('benutzer').delete().eq('id', delConfirm.id)
    setDelConfirm(null); setDeleting(false); laden()
  }

  return (
    <>
      {/* Neuer Benutzer */}
      <div style={{ background: '#f8fafc', borderRadius: 10, padding: '18px 20px', marginBottom: 24, border: '1px solid #e5e7eb' }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: '#0d1b2a', marginBottom: 14 }}>Neuen Benutzer anlegen</div>
        <form onSubmit={hinzufuegen}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, marginBottom: 12 }}>
            <div>
              <label style={lbl}>Benutzername</label>
              <input style={inp} placeholder="z.B. meister1" value={form.benutzername}
                onChange={e => setForm({ ...form, benutzername: e.target.value })} autoComplete="off" />
            </div>
            <div>
              <label style={lbl}>E-Mail</label>
              <input style={inp} type="email" placeholder="name@firma.de" value={form.email}
                onChange={e => setForm({ ...form, email: e.target.value })} autoComplete="off" />
            </div>
            <div>
              <label style={lbl}>Passwort (mind. 6 Zeichen)</label>
              <input style={inp} type="password" placeholder="••••••" value={form.passwort}
                onChange={e => setForm({ ...form, passwort: e.target.value })} autoComplete="new-password" />
            </div>
          </div>
          {error   && <div style={{ color: '#c53030', fontSize: 12, marginBottom: 8, background: '#fff5f5', padding: '6px 10px', borderRadius: 6 }}>⚠ {error}</div>}
          {success && <div style={{ color: '#276749', fontSize: 12, marginBottom: 8, background: '#f0fff4', padding: '6px 10px', borderRadius: 6 }}>✓ {success}</div>}
          <button type="submit" disabled={loading}
            style={{ padding: '8px 20px', background: '#ffc000', color: '#111111', border: 'none', borderRadius: 7, cursor: 'pointer', fontWeight: 800, fontSize: 13 }}>
            {loading ? 'Anlegen...' : '+ Benutzer anlegen'}
          </button>
        </form>
      </div>

      {/* Liste */}
      <div style={{ borderRadius: 10, overflow: 'hidden', border: '1px solid #e5e7eb' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr>
              {['Benutzername','E-Mail','Angelegt','Aktionen'].map(h => (
                <th key={h} style={{ background: '#0d1b2a', color: '#fff', padding: '10px 14px', textAlign: 'left', fontSize: 12 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {liste.map((b, i) => (
              <tr key={b.id} style={{ background: i % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                <td style={td}>
                  {editId === b.id
                    ? <input style={{ ...inp, padding: '4px 8px', width: 140 }} value={editName}
                        onChange={e => setEditName(e.target.value)}
                        onKeyDown={e => { if (e.key === 'Enter') benutzernameAendern(b.id); if (e.key === 'Escape') setEditId(null) }} autoFocus />
                    : <strong>{b.benutzername}</strong>}
                </td>
                <td style={td}><span style={{ color: '#555' }}>{b.email}</span></td>
                <td style={td}>{new Date(b.created_at).toLocaleDateString('de-DE')}</td>
                <td style={{ ...td, whiteSpace: 'nowrap' }}>
                  {editId === b.id ? (
                    <>
                      <button onClick={() => benutzernameAendern(b.id)} style={saveBtn}>✓</button>
                      <button onClick={() => setEditId(null)} style={cancelBtn}>✕</button>
                    </>
                  ) : (
                    <>
                      <button onClick={() => { setEditId(b.id); setEditName(b.benutzername) }} style={editBtn}>✏ Umbenennen</button>
                      <button onClick={() => setDelConfirm(b)} style={delBtn}>Entfernen</button>
                    </>
                  )}
                </td>
              </tr>
            ))}
            {liste.length === 0 && (
              <tr><td colSpan={4} style={{ textAlign: 'center', padding: 32, color: '#999' }}>Keine Benutzer</td></tr>
            )}
          </tbody>
        </table>
      </div>

      <div style={{ marginTop: 14, background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 8, padding: '10px 14px', fontSize: 12, color: '#92400e', lineHeight: 1.6 }}>
        <strong>Hinweis:</strong> Nur Benutzer in dieser Liste haben Zugriff auf die Daten (Fahrzeuge, Leihwagen, Statistiken).
        Beim <strong>Entfernen</strong> wird der Datenzugriff sofort entzogen.
        Damit neue Benutzer ohne E-Mail-Bestätigung aktiv sind, muss in Supabase <em>„Confirm email"</em> deaktiviert sein.
      </div>

      {/* Delete Confirm */}
      {delConfirm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 300 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: '28px 32px', width: 340, textAlign: 'center', boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}>
            <div style={{ fontSize: 36, marginBottom: 10 }}>👤</div>
            <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 6 }}>Benutzer entfernen?</div>
            <div style={{ fontSize: 13, color: '#666', marginBottom: 4 }}><strong>{delConfirm.benutzername}</strong> ({delConfirm.email})</div>
            <div style={{ fontSize: 12, color: '#999', marginBottom: 20 }}>Der Login-Zugang wird sofort gesperrt.</div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
              <button onClick={() => setDelConfirm(null)}
                style={{ padding: '10px 22px', border: '1px solid #ddd', borderRadius: 8, background: '#fff', cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>Abbrechen</button>
              <button onClick={loeschen} disabled={deleting}
                style={{ padding: '10px 22px', border: 'none', borderRadius: 8, background: '#dc2626', color: '#fff', cursor: 'pointer', fontSize: 14, fontWeight: 700 }}>
                {deleting ? 'Entfernen...' : 'Entfernen'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

/* ── Main Component ───────────────────────────────────── */
export default function Einstellungen({ userRole, benutzername }) {
  const [tab, setTab] = useState('passwort')

  const tabs = [
    { key: 'passwort',  label: '🔑 Passwort' },
    ...(userRole === 'admin' ? [
      { key: 'benutzer',  label: '👥 Benutzer' },
    ] : []),
  ]

  return (
    <div style={{ padding: 24, maxWidth: 800 }}>
      <h2 style={{ margin: '0 0 20px', fontSize: 20, fontWeight: 800 }}>Einstellungen</h2>

      {/* Tabs */}
      <div style={{ display: 'flex', borderBottom: '2px solid #e5e7eb', marginBottom: 24, gap: 0 }}>
        {tabs.map(t => (
          <button key={t.key} onClick={() => setTab(t.key)} style={{
            padding: '9px 22px', border: 'none', background: 'none', cursor: 'pointer',
            fontWeight: tab === t.key ? 700 : 500, fontSize: 14,
            color: tab === t.key ? '#0d1b2a' : '#6b7280',
            borderBottom: tab === t.key ? '3px solid #ffc000' : '3px solid transparent',
            marginBottom: -2,
          }}>{t.label}</button>
        ))}
      </div>

      {tab === 'passwort'  && <PasswortTab benutzername={benutzername} />}
      {tab === 'benutzer'  && userRole === 'admin' && <BenutzerTab />}
    </div>
  )
}

const lbl       = { display: 'block', fontSize: 11, fontWeight: 600, color: '#6b7280', marginBottom: 4 }
const inp       = { width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 7, fontSize: 13, boxSizing: 'border-box' }
const td        = { padding: '9px 14px', borderBottom: '1px solid #f0f0f0', verticalAlign: 'middle' }
const editBtn   = { padding: '4px 10px', background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe', borderRadius: 5, cursor: 'pointer', fontSize: 11, fontWeight: 700, marginRight: 6 }
const delBtn    = { padding: '4px 10px', background: '#fff5f5', color: '#c53030', border: '1px solid #fecaca', borderRadius: 5, cursor: 'pointer', fontSize: 11, fontWeight: 700 }
const saveBtn   = { padding: '4px 10px', background: '#48bb78', color: '#fff', border: 'none', borderRadius: 5, cursor: 'pointer', marginRight: 4, fontWeight: 700 }
const cancelBtn = { padding: '4px 10px', background: '#dc2626', color: '#fff', border: 'none', borderRadius: 5, cursor: 'pointer', fontWeight: 700 }
